import { get } from '../../../helpers/axios';

export const getStatisticsDetail = ({initDate,limitDate, businessId}) => get(`campaign-message/statistics`,{params:{initDate,limitDate, businessId}});

export const getStatisticsGrouped = ({initDate,limitDate, businessId, page, limit}) => get(`campaign-message/statistics/grouped`,{params:{initDate,limitDate, businessId, page, limit}});